import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Suppress development warnings
import './utils/suppressWarnings'
import { installPrintBridge } from './lib/printBridge'
import { restoreGridPrefs } from './lib/gridDensity'
import { applyCachedBrand } from './lib/brand'

// Core Settings ▸ Appearance: put the device's stored grid preferences on the
// document BEFORE the first render, so grids honour them on every screen —
// not only after the Appearance page has been visited.
restoreGridPrefs()

// Core Settings ▸ Brand Management: paint the last known brand from cache on
// the first frame. Without this the app opens in LabBOXX blue and repaints to
// the tenant's colour when the fetch lands, which reads as a bug. The
// authoritative value is fetched in App and overwrites this.
//
// One call covers BOTH modes: applyBrandColor writes a stylesheet carrying a
// `:root` and a `:root.dark` block, so flipping the theme re-paints through
// the cascade. The MutationObserver that used to re-derive the brand on every
// flip was only needed because the override was inline on <html>, where it
// outranked the `.dark` block.
applyCachedBrand()

// Universal: when the local BOXX Print Bridge agent is installed, every
// window.print() routes silently to the chosen/Windows-default printer; without
// it the normal dialog runs unchanged. Specimen labels (ReprintLabelsPage) use
// the bridge directly for silent batch label printing.
installPrintBridge({ rememberKey: 'labboxx' })

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
